import { render } from "./CouponPage.vue?vue&type=template&id=01d648dd"
import script from "./CouponPage.vue?vue&type=script&lang=js"
export * from "./CouponPage.vue?vue&type=script&lang=js"

import "./CouponPage.vue?vue&type=style&index=0&id=01d648dd&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__